import React from "react";

const LoadingPage = () => {
  return (
    <div className="bg-gradient-custom loading-page h-screen w-screen">
      <span className="loader"></span>
    </div>
  );
};

export default LoadingPage;
